import {
  AuthData,
  InviteData,
  RecoverData,
  SignupData,
} from 'app/store/lib/authStore';
import { axiosApi } from './api';

export const authApi = {
  login: async (data: AuthData) => {
    const fd = new FormData();
    fd.set('username', data.username.toLowerCase());
    fd.set('password', data.password);

    const res = await axiosApi.post<{ access_token: string }>(`/login`, fd);
    return res.data;
  },

  sendSignupLink: async (data: InviteData) => {
    const res = await axiosApi.post<string>(
      '/profiles/send_sign_request',
      {},
      {
        params: {
          name: data.name,
          surname: data.surname,
          email: data.email.toLowerCase(),
        },
      }
    );

    return res.data;
  },

  sendRestoreLink: async (data: { email: string }) => {
    await axiosApi.get<void>(`/profiles/send_restore_email`, {
      params: { email: data.email.toLowerCase() },
    });

    return true;
  },

  verifySignupLink: async (data: { code: string }) => {
    const res = await axiosApi.get<any>(`/profiles/${data.code}`);

    return res.data;
  },
  verifyRestoreLink: async (data: { code: string }) => {
    const res = await axiosApi.get<any>(
      `/profiles/verify_restore_password_code?code=${data.code}`
    );

    return res.data;
  },

  signup: async (data: SignupData) => {
    const res = await axiosApi.post<{ email: string }>(
      `/profiles/signup`,
      data
    );

    return res.data;
  },

  recover: async (data: RecoverData) => {
    const res = await axiosApi.post<string>(
      `/profiles/restore_password?password=${data.password}&code=${data.code}`
    );

    return res.data;
  },
};
